import cassapanca from '../images/cassapanca.jpg'

function Cassapanca() {
	return (
		<center>
		<p className='Cassapanca'>Ciao da Lorenzo e Laura!</p>
		<img src={cassapanca} alt="cassapanca"/>
		</center>
	)
}

export default Cassapanca;



		

